import { render, staticRenderFns } from "./PaymentPlanOption.vue?vue&type=template&id=5bbd5903"
import script from "./PaymentPlanOption.vue?vue&type=script&lang=js"
export * from "./PaymentPlanOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_css-loader@6.11.0_webpack@5.102.0__lodash@4_9e7f287e1541e9ab10d10bde1bb44969/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports